import React, { useState } from "react";
import { View } from "react-native";

import CalendarDescription from "./CalendarDescription";
import IntegrationsHelper from "../../IntegrationsHelper";
import CalendarSignIn from "./CalendarSignIn";
import CalendarAccount from "./CalendarAccount";
import CarouselProgressBar from "../../../animation/progressBar/CarouselProgressBar";
import ProgressBarConfig from "../../../animation/progressBar/config";

export default function CalendarIntegrationPage(props) {
  const { controller, goToStep, step } = props;
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [calendarType, setCalendarType] = useState(null);
  const [showSignIn, setShowSignIn] = useState(false);

  const currentScreenIndex = ProgressBarConfig["integrationsCalendar"];
  const numberOfScreens = Object.keys(ProgressBarConfig).length;

  const _onAuthorizeDone = (calType, email) => {
    IntegrationsHelper.saveIntegrations(
      controller,
      {
        [calType]: true,
      },
      () => {
        controller.refreshIntegrations(true);
        setSelectedAccount({
          email: email,
        });
      },
    );
  };

  const connect = (calType) => {
    setCalendarType(calType);
    const isGoogle = calType.includes("google");
    setShowSignIn(isGoogle);

    IntegrationsHelper.authorizeIntegration(
      controller,
      {
        [calType]: true,
      },
      (type, events, email) => {
        _onAuthorizeDone(calType, email);
      },
    );
  };

  const goBack = () => {
    if (selectedAccount || showSignIn) {
      setSelectedAccount(null);
      setShowSignIn(false);
    } else {
      goToStep(step - 1);
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <CarouselProgressBar
        currentScreenIndex={currentScreenIndex}
        numberOfScreens={numberOfScreens}
        changeScreen={goBack}
        hideNext
      />

      {selectedAccount ? (
        <CalendarAccount account={selectedAccount} goBack={goBack} {...props} />
      ) : showSignIn ? (
        <CalendarSignIn connect={() => connect(calendarType)} />
      ) : (
        <CalendarDescription connect={connect} {...props} />
      )}
    </View>
  );
}
